import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faDesktop, 
  faCalculator, 
  faCube, 
  faTools,
  faDraftingCompass,
  faClipboardList
} from '@fortawesome/free-solid-svg-icons';
import ConsentEmbed from '../common/ConsentEmbed';
import '../../styles/ServicePage.css';

const SoftwarePage: React.FC = () => {
  return (
    <div className="service-page">
      {/* Header Section */}
      <header className="service-header">
        <div className="container">
          <div className="service-header-content">
            <h1>Software & Tools</h1>
            <p>
              Moderne Software-Lösungen für präzise Planung und effiziente Projektabwicklung
            </p>
          </div>
        </div>
      </header>

      <div className="service-content">
        <div className="container">
          {/* Intro Section */}
          <section className="service-section">
            <div className="service-intro">
              <p>
                Das Ingenieurbüro Neubaur setzt auf modernste Software-Tools, um höchste Qualität 
                und Effizienz in der Projektplanung und -durchführung zu gewährleisten. Von der 
                ersten Skizze bis zur detaillierten Kostenberechnung nutzen wir spezialisierte 
                Programme für jeden Arbeitsbereich.
              </p>
            </div>
          </section>

          {/* Zeichnungssoftware Section */}
          <section className="service-section">
            <h2 className="service-section-title">
              <FontAwesomeIcon icon={faDraftingCompass} /> 
              Zeichnungs- und Planungssoftware
            </h2>
            
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">
                  <FontAwesomeIcon icon={faDesktop} />
                </div>
                <div className="feature-content">
                  <h3>Revit</h3>
                  <p>
                    Professionelle BIM-Software für die integrale Gebäudeplanung. Ermöglicht 
                    3D-Modellierung, koordinierte Planung und automatische Dokumentation 
                    nach aktuellen BIM-Standards.
                  </p>
                  <ul>
                    <li>3D-BIM-Modellierung</li>
                    <li>Koordinierte Fachplanung</li>
                    <li>Automatische Pläne und Listen</li>
                    <li>Kollisionsprüfung</li>
                  </ul>
                </div>
              </div>
              
              <div className="feature-item">
                <div className="feature-icon">
                  <FontAwesomeIcon icon={faTools} />
                </div>
                <div className="feature-content">
                  <h3>AutoCAD & Zusatzmodule</h3>
                  <p>
                    Standardisierte CAD-Umgebung für technische Zeichnungen und Grundrisse. 
                    Erweitert durch spezialisierte Module für verschiedene Fachbereiche.
                  </p>
                  <ul>
                    <li>2D- und 3D-Konstruktion</li>
                    <li>Parametrische Zeichnungen</li>
                    <li>Blockbibliotheken</li>
                    <li>Layoutvorlagen</li>
                  </ul>
                </div>
              </div>
              
              <div className="feature-item">
                <div className="feature-icon">
                  <FontAwesomeIcon icon={faDraftingCompass} />
                </div>
                <div className="feature-content">
                  <h3>dds-cad</h3>
                  <p>
                    Spezialisierte CAD-Software für Gebäudetechnik mit intelligenten 
                    Planungswerkzeugen für Elektro-, HLS- und Versorgungstechnik.
                  </p>
                  <ul>
                    <li>Gebäudetechnik-spezifische Planung</li>
                    <li>Intelligente Bauteilbibliotheken</li>
                    <li>Automatische Strangschemen</li>
                    <li>Integrierte AVA-Schnittstellen</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* Kostenberechnung Section */}
          <section className="service-section">
            <h2 className="service-section-title">
              <FontAwesomeIcon icon={faCalculator} /> 
              Kostenberechnung und Kalkulation
            </h2>
            
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">
                  <FontAwesomeIcon icon={faCalculator} />
                </div>
                <div className="feature-content">
                  <h3>California Kostenberechnung</h3>
                  <p>
                    Spezialisierte Software für präzise Kostenermittlung im Bauwesen. 
                    Ermöglicht detaillierte Kalkulationen und transparente Kostenaufstellungen.
                  </p>
                  <ul>
                    <li>Normgerechte Kostengruppen nach DIN 276</li>
                    <li>Automatische Mengenermittlung</li>
                    <li>Aktuelle Preisdatenbanken</li>
                    <li>Kostencontrolling und -verfolgung</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* Projektmanagement Section */}
          <section className="service-section">
            <h2 className="service-section-title">
              <FontAwesomeIcon icon={faClipboardList} /> 
              Projektmanagement
            </h2>
            
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">
                  <FontAwesomeIcon icon={faClipboardList} />
                </div>
                <div className="feature-content">
                  <h3>ProjektPro</h3>
                  <p>
                    Umfassende Projektmanagement-Software für die koordinierte Abwicklung 
                    komplexer Bauprojekte. Von der Planung bis zur Übergabe.
                  </p>
                  <ul>
                    <li>Terminplanung und Ressourcenverwaltung</li>
                    <li>Dokumentenmanagement</li>
                    <li>Kostenüberwachung</li>
                    <li>Team-Kollaboration</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* 3D-Bestandsaufnahme Section */}
          <section className="service-section">
            <h2 className="service-section-title">
              <FontAwesomeIcon icon={faCube} /> 
              3D-Bestandsaufnahme und Vermessung
            </h2>
            
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">
                  <FontAwesomeIcon icon={faCube} />
                </div>
                <div className="feature-content">
                  <h3>OpenSpace</h3>
                  <p>
                    Moderne 3D-Aufnahmetechnologie für präzise Bestandserfassung. 
                    Ermöglicht virtuelle Begehungen und millimetergenaue Vermessungen.
                  </p>
                  <ul>
                    <li>360°-Panoramaaufnahmen</li>
                    <li>Präzise Maßaufnahme</li>
                    <li>Virtuelle Begehungen</li>
                    <li>Integration in CAD-Systeme</li>
                  </ul>
                </div>
              </div>
            </div>
            
            {/* OpenSpace Video */}
            <div style={{ marginTop: '3rem', maxWidth: '900px', marginLeft: 'auto', marginRight: 'auto' }}>
              <div style={{ 
                background: 'white', 
                padding: '2rem', 
                borderRadius: '12px', 
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' 
              }}>
                <h3 style={{ marginBottom: '1.5rem', textAlign: 'center', color: 'var(--primary-color)' }}>
                  OpenSpace in Aktion
                </h3>
                <div style={{
                  position: 'relative',
                  paddingBottom: '56.25%',
                  height: 0,
                  overflow: 'hidden',
                  borderRadius: '8px'
                }}>
                  <ConsentEmbed
                    category="externalMedia"
                    providerName="YouTube"
                    description="Beim Laden des Videos werden Daten an YouTube/Google (Google Ireland Ltd. / Google LLC, USA) übertragen. Wir nutzen den erweiterten Datenschutz-Modus (youtube-nocookie.com)."
                    privacyPolicyUrl="https://policies.google.com/privacy"
                    ariaLabel="Video: OpenSpace 3D-Aufnahmetechnologie"
                    className="consent-embed-fill"
                  >
                    <iframe
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none'
                      }}
                      src="https://www.youtube-nocookie.com/embed/jmlb5cRHMRY"
                      title="OpenSpace 3D-Aufnahmetechnologie"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    ></iframe>
                  </ConsentEmbed>
                </div>
              </div>
            </div>
          </section>

          {/* Integration Section */}
          <section className="service-section">
            <h2 className="service-section-title">Softwareintegration und Workflow</h2>
            
            <div className="service-intro">
              <p>
                Alle eingesetzten Softwarelösungen sind optimal aufeinander abgestimmt und 
                ermöglichen einen nahtlosen Datenaustausch zwischen den verschiedenen 
                Projektphasen. Dies gewährleistet höchste Effizienz und minimiert Fehlerquellen.
              </p>
              
              <div className="workflow-steps" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', marginTop: '2rem' }}>
                <div className="workflow-step" style={{ textAlign: 'center', padding: '1rem', background: 'rgba(183, 28, 28, 0.05)', borderRadius: '8px' }}>
                  <FontAwesomeIcon icon={faCube} style={{ fontSize: '2rem', color: 'var(--accent-color)', marginBottom: '0.5rem' }} />
                  <h4>Bestandsaufnahme</h4>
                  <p>3D-Scanning mit OpenSpace</p>
                </div>
                
                <div className="workflow-step" style={{ textAlign: 'center', padding: '1rem', background: 'rgba(183, 28, 28, 0.05)', borderRadius: '8px' }}>
                  <FontAwesomeIcon icon={faDraftingCompass} style={{ fontSize: '2rem', color: 'var(--accent-color)', marginBottom: '0.5rem' }} />
                  <h4>Planung</h4>
                  <p>BIM-Modellierung mit Revit</p>
                </div>
                
                <div className="workflow-step" style={{ textAlign: 'center', padding: '1rem', background: 'rgba(183, 28, 28, 0.05)', borderRadius: '8px' }}>
                  <FontAwesomeIcon icon={faCalculator} style={{ fontSize: '2rem', color: 'var(--accent-color)', marginBottom: '0.5rem' }} />
                  <h4>Kalkulation</h4>
                  <p>Kostenberechnung mit California</p>
                </div>
                
                <div className="workflow-step" style={{ textAlign: 'center', padding: '1rem', background: 'rgba(183, 28, 28, 0.05)', borderRadius: '8px' }}>
                  <FontAwesomeIcon icon={faClipboardList} style={{ fontSize: '2rem', color: 'var(--accent-color)', marginBottom: '0.5rem' }} />
                  <h4>Projektmanagement</h4>
                  <p>Koordination mit ProjektPro</p>
                </div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="service-section">
            <div className="cta-section" style={{ background: 'linear-gradient(135deg, var(--primary-color), var(--secondary-color))', color: 'white', padding: '3rem 2rem', borderRadius: '12px', textAlign: 'center' }}>
              <h2 style={{ color: 'white', marginBottom: '1rem' }}>Modernste Technologie für Ihr Projekt</h2>
              <p style={{ fontSize: '1.1rem', marginBottom: '2rem', opacity: '0.9' }}>
                Profitieren Sie von unserer hochmodernen Software-Ausstattung und jahrelangen 
                Erfahrung im Umgang mit professionellen Planungstools.
              </p>
              <a href="/kontakt" className="btn btn-light" style={{ background: 'white', color: 'var(--primary-color)', padding: '0.75rem 2rem', borderRadius: '25px', textDecoration: 'none', fontWeight: '600' }}>
                Nehmen Sie Kontakt auf
              </a>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default SoftwarePage;

